import React from 'react';
import Modal from 'react-modal';
import i18 from '../../../i18';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

class RuleViewModal extends React.Component {
    getDisplayValue = (value, suffix) => {
        if (
            value === null
            || typeof value === 'undefined'
            || value === ''
        ) {
            return '-';
        }

        return suffix
            ? String(value) + suffix
            : value;
    };

    getCollectorCode = () => {
        const {rule} = this.props;

        if (
            rule.vatCollectorCode
            && rule.vatCollectorCode.code
        ) {
            return rule.vatCollectorCode.code;
        }

        if (
            rule.vatCode
            && rule.vatCode.code
        ) {
            return rule.vatCode.code;
        }

        if (rule.vat_collector_code) {
            return rule.vat_collector_code;
        }

        return '-';
    };

    getCompanyType = () => {
        const {rule} = this.props;

        return (
            rule.company_type_label
            || rule.companyType
            || rule.company_type
            || '-'
        );
    };

    getRuleType = () => {
        const {rule} = this.props;

        return (
            rule.type_label
            || rule.typeLabel
            || rule.type
            || '-'
        );
    };

    renderRow = (label, value) => {
        return (
            <tr>
                <td>{label}</td>
                <td>{this.getDisplayValue(value)}</td>
            </tr>
        );
    };

    render() {
        const {
            rule,
            closeModal,
        } = this.props;

        if (!rule) {
            return null;
        }

        return (
            <Modal
                isOpen={true}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={i18.COMMON._showRuleText}
            >
                <div className="modal-body">
                    <table className="table table-striped table-aibook-no-border">
                        <tbody>
                        {this.renderRow('Azonosító', '#' + rule.id)}
                        {this.renderRow(i18.CUSTOMER._typeOfTraffic, rule.item_name)}
                        {this.renderRow(i18.CUSTOMER._invoiceNumber, rule.invoice_number)}
                        {this.renderRow(i18.CUSTOMER._orderNumberStat, rule.order_number_stat)}
                        {this.renderRow(i18.CUSTOMER._positionNumber, rule.position_number)}
                        {this.renderRow(i18.CUSTOMER._positionNumberCountry, rule.position_number_country)}
                        {this.renderRow(i18.CUSTOMER._mainBookNumber, rule.main_bookkeeping_number)}
                        {this.renderRow(i18.CUSTOMER._VAT, this.getDisplayValue(rule.vat, '%'))}
                        {this.renderRow(i18.CUSTOMER._collectorCode, this.getCollectorCode())}
                        {this.renderRow(i18.CUSTOMER._taxNumber, this.getCompanyType())}
                        {this.renderRow(i18.CUSTOMER._vatDegreeNumber, rule.vat_degree)}
                        {this.renderRow(i18.COMMON._typeOfRule, this.getRuleType())}
                        {this.renderRow(i18.COMMON._position, rule.position)}
                        {this.renderRow(i18.COMMON._updatedAt, rule.updated_at)}
                        </tbody>
                    </table>

                    <div className="text-center">
                        <button
                            type="button"
                            onClick={closeModal}
                            className="btn btn-danger btn-sm"
                        >
                            {i18.COMMON._close}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default RuleViewModal;


// WEBPACK FOOTER //
// ./src/components/customer/rules/RuleViewModal.js